import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  paginationContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  right: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
